import React from "react";
import theme from "theme";
import { Theme, Text, Image, Section, Strong, Box, Link, Input } from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml, Override } from "@quarkly/components";
import * as Components from "components";
export default (() => {
	return <Theme theme={theme}>
		<GlobalQuarklyPageStyles pageUrl={"index"} />
		<Helmet>
			<title>
				Green Bliss Café Franchise
			</title>
			<meta name={"description"} content={"Welcome to Green Bliss Café, the home of plant-based dining where sustainability meets indulgence!"} />
			<meta property={"og:title"} content={"Green Bliss Café Franchise"} />
			<meta property={"og:description"} content={"Місце для тих,Welcome to Green Bliss Café, the home of plant-based dining where sustainability meets indulgence! хто любить біг і прагне відчути силу руху, свободи та спільність з однодумцями."} />
			<meta property={"og:image"} content={"https://uploads.quarkly.io/67604c2fe5d27700189a24f0/images/Plant-Up.png?v=2024-12-16T16:23:23.563Z"} />
			<link rel={"shortcut icon"} href={"https://uploads.quarkly.io/67604c2fe5d27700189a24f0/images/Plant-Up.png?v=2024-12-16T16:23:23.563Z"} type={"image/x-icon"} />
			<link rel={"apple-touch-icon"} href={"https://uploads.quarkly.io/67604c2fe5d27700189a24f0/images/Plant-Up.png?v=2024-12-16T16:23:23.563Z"} />
			<link rel={"apple-touch-icon"} sizes={"76x76"} href={"https://uploads.quarkly.io/67604c2fe5d27700189a24f0/images/Plant-Up.png?v=2024-12-16T16:23:23.563Z"} />
			<link rel={"apple-touch-icon"} sizes={"152x152"} href={"https://uploads.quarkly.io/67604c2fe5d27700189a24f0/images/Plant-Up.png?v=2024-12-16T16:23:23.563Z"} />
			<link rel={"apple-touch-startup-image"} href={"https://uploads.quarkly.io/67604c2fe5d27700189a24f0/images/Plant-Up.png?v=2024-12-16T16:23:23.563Z"} />
			<meta name={"msapplication-TileImage"} content={"https://uploads.quarkly.io/67604c2fe5d27700189a24f0/images/Plant-Up.png?v=2024-12-16T16:23:23.563Z"} />
			<meta name={"msapplication-TileColor"} content={"#0CAD1C"} />
		</Helmet>
		<Components.Header3 />
		<Section padding="60px 0 20px 0" quarkly-title="HeroBlock">
			<Text
				color="--dark"
				lg-font="normal 800 40px/1.2 &quot;Manrope&quot;, sans-serif"
				md-font="normal 800 28px/1.2 &quot;Manrope&quot;, sans-serif"
				margin="0px 0px 0px 0px"
				font="--headline1"
			>
				Green Bliss Café Franchise
			</Text>
			<Image
				max-height="600px"
				object-position="center"
				lg-max-height="300px"
				md-max-height="200px"
				sm-max-height="150px"
				src="https://images.unsplash.com/photo-1493770348161-369560ae357d?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=2000"
				width="100%"
				object-fit="cover"
				margin="32px 0px 0px 0px"
				srcSet="https://images.unsplash.com/photo-1493770348161-369560ae357d?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=500 500w,https://images.unsplash.com/photo-1493770348161-369560ae357d?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=800 800w,https://images.unsplash.com/photo-1493770348161-369560ae357d?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=1080 1080w,https://images.unsplash.com/photo-1493770348161-369560ae357d?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=1600 1600w,https://images.unsplash.com/photo-1493770348161-369560ae357d?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=2000 2000w,https://images.unsplash.com/photo-1493770348161-369560ae357d?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=2600 2600w,https://images.unsplash.com/photo-1493770348161-369560ae357d?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=3200 3200w"
				sizes="(max-width: 576px) 100vw,(max-width: 767px) 100vw,(max-width: 992px) 100vw,100vw"
			/>
		</Section>
		<Section padding="28px 0 74px 0" md-padding="28px 0 28px 0">
			<Override slot="SectionContent" flex-direction="row" md-flex-wrap="wrap" />
			<Box
				empty-min-height="64px"
				empty-border-width="1px"
				empty-border-style="solid"
				empty-border-color="LightGray"
				width="40%"
				display="flex"
				md-width="100%"
				empty-min-width="64px"
				font="--headline4"
			>
				<Text
					margin="0px 0px 0px 0px"
					font="--headline4"
					color="--dark"
					lg-font="normal 700 28px/1.2 &quot;Manrope&quot;, sans-serif"
					sm-font="normal 700 22px/1.2 &quot;Manrope&quot;, sans-serif"
				>
					Welcome to{" "}
					<Strong
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						Green Bliss Café
					</Strong>
					, the home of plant-based dining where sustainability meets indulgence!
				</Text>
			</Box>
			<Box
				md-width="100%"
				empty-min-height="64px"
				empty-border-color="LightGray"
				padding="0px 0px 0px 10%"
				width="60%"
				display="flex"
				md-padding="0px 0px 0px 0px"
				md-margin="32px 0px 0px 0px"
				empty-min-width="64px"
				empty-border-width="1px"
				empty-border-style="solid"
			>
				<Text
					margin="0px 0px 0px 0px"
					font="--lead"
					color="--dark"
					lg-font="normal 400 16px/1.5 &quot;Manrope&quot;, sans-serif"
					sm-font="normal 400 14px/1.5 &quot;Manrope&quot;, sans-serif"
					md-font="normal 400 14px/1.5 &quot;Manrope&quot;, sans-serif"
				>
					With the growing demand for healthier lifestyles and eco-friendly choices, Green Bliss Café has become a leader in offering flavorful, plant-based meals served in an inspiring, community-centered environment.
				</Text>
			</Box>
		</Section>
		<Section padding="80px 0 80px 0" sm-padding="60px 0 60px 0" background="--color-darkL2">
			<Override slot="SectionContent" flex-direction="row" md-flex-wrap="wrap" />
			<Box
				width="50%"
				display="flex"
				flex-direction="column"
				justify-content="space-between"
				md-width="100%"
				padding="0px 80px 0px 0px"
				lg-padding="0px 30px 0px 0px"
				md-padding="0px 0px 0px 0px"
			>
				<Text margin="0px 0px 0px 0px" color="--light" font="--headline3" md-margin="0px 0px 30px 0px">
					Since our inception in 2018, we have been driven by one goal
				</Text>
			</Box>
			<Box
				width="50%"
				display="flex"
				flex-direction="column"
				justify-content="space-between"
				md-width="100%"
			>
				<Text margin="0px 0px 0px 0px" color="#F7FBFF" font="--base">
					to redefine the dining experience by offering a menu that nourishes the body and nurtures the planet. From our signature smoothie bowls to hearty plant-based burgers, every item on our menu is crafted with care, using fresh, locally sourced ingredients.
				</Text>
			</Box>
		</Section>
		<Section padding="80px 0 80px 0" sm-padding="60px 0 60px 0" background="--color-indigo">
			<Override slot="SectionContent" flex-direction="row" md-flex-wrap="wrap" />
			<Box
				width="50%"
				display="flex"
				flex-direction="column"
				justify-content="space-between"
				md-width="100%"
				padding="0px 80px 0px 0px"
				lg-padding="0px 30px 0px 0px"
				md-padding="0px 0px 0px 0px"
			>
				<Text margin="0px 0px 0px 0px" color="--light" font="--headline3" md-margin="0px 0px 30px 0px">
					Our journey began{" "}
				</Text>
			</Box>
			<Box
				width="50%"
				display="flex"
				flex-direction="column"
				justify-content="space-between"
				md-width="100%"
			>
				<Text margin="0px 0px 0px 0px" color="#F7FBFF" font="--base">
					with a single café in a small town and has since expanded to a nationwide network of over 50 locations. Our customers return time and again for the vibrant atmosphere, exceptional service, and delicious meals that fuel their wellness journey. As we continue to grow, we are looking for passionate entrepreneurs like you to join us in spreading the Green Bliss mission.
				</Text>
			</Box>
		</Section>
		<Section padding="80px 0 80px 0" sm-padding="60px 0 60px 0" background="--color-darkL2">
			<Override slot="SectionContent" flex-direction="row" md-flex-wrap="wrap" />
			<Box
				width="50%"
				display="flex"
				flex-direction="column"
				justify-content="space-between"
				md-width="100%"
				padding="0px 80px 0px 0px"
				lg-padding="0px 30px 0px 0px"
				md-padding="0px 0px 0px 0px"
			>
				<Text margin="0px 0px 0px 0px" color="--light" font="--headline3" md-margin="0px 0px 30px 0px">
					Becoming a Green Bliss Café franchise owner
				</Text>
			</Box>
			<Box
				width="50%"
				display="flex"
				flex-direction="column"
				justify-content="space-between"
				md-width="100%"
			>
				<Text margin="0px 0px 0px 0px" color="#F7FBFF" font="--base">
					means more than running a business—it’s about being part of a movement that values health, community, and environmental responsibility. Together, we can inspire change and create meaningful connections, one café at a time.
				</Text>
			</Box>
		</Section>
		<Section padding="40px 0 40px 0" background="--color-indigo" quarkly-title="Description-11">
			<Override
				slot="SectionContent"
				flex-wrap="wrap"
				max-width="1440px"
				align-items="flex-start"
				flex-direction="row"
			/>
			<Box width="100%" margin="3vw 0px 0px 0px">
				<Text
					margin="0px 0px 0px 0px"
					font="--headline1"
					color="--light"
					letter-spacing="-.05em"
					lg-font="normal 400 70px/1.1em &quot;Inter&quot;, sans-serif"
					sm-font="normal 400 40px/1.1em &quot;Inter&quot;, sans-serif"
				>
					<Strong>
						Why Choose Our Franchise?
					</Strong>
				</Text>
				<Text margin="40px 0px 0px 0px" font="--base" color="--light" width="60%">
					Starting your entrepreneurial journey with Green Bliss Café means you’re partnering with a trusted, fast-growing brand that provides unwavering support and guidance. Here’s what sets us apart:
					<br />
				</Text>
			</Box>
			<Box
				margin="156px 0px 100px 0px"
				lg-margin="56px 0px 30px 0px"
				md-display="none"
				width="33.333%"
				padding="20px 20px 20px 20px"
			/>
			<Box
				width="33.333%"
				padding="20px 20px 20px 20px"
				margin="156px 0px 100px 0px"
				lg-margin="56px 0px 30px 0px"
				md-width="50%"
				sm-margin="20px 0px 20px 0px"
				sm-width="100%"
			>
				<Text margin="0px 0px 0px 0px" font="--headline3" color="--light">
					A Fast-Growing Market
				</Text>
				<Text margin="40px 0px 0px 0px" font="--base" color="--light">
					The plant-based food industry is one of the fastest-growing markets globally, with a projected value of over $77 billion by 2025. People are seeking healthier options, whether they are lifelong vegans, flexitarians, or simply curious foodies. Green Bliss Café stands at the forefront of this revolution, offering a proven business model in a booming industry.
					<br />
					<br />
				</Text>
			</Box>
			<Box
				sm-width="100%"
				width="33.333%"
				padding="20px 20px 20px 20px"
				margin="156px 0px 100px 0px"
				lg-margin="56px 0px 30px 0px"
				md-width="50%"
				sm-margin="20px 0px 20px 0px"
			>
				<Text margin="0px 0px 0px 0px" font="--headline3" color="--light">
					A Well-Established Brand
				</Text>
				<Text margin="40px 0px 0px 0px" font="--base" color="--light">
					Our brand resonates with modern consumers who value sustainability, wellness, and high-quality dining experiences. Green Bliss Café has become synonymous with vibrant, nutritious meals served in a welcoming and eco-conscious environment.
					<br />
					<br />
				</Text>
			</Box>
			<Box
				md-width="50%"
				sm-margin="20px 0px 20px 0px"
				sm-width="100%"
				width="60%"
				padding="20px 20px 20px 20px"
				margin="156px 0px 100px 0px"
				lg-margin="56px 0px 30px 0px"
			>
				<Text margin="0px 0px 0px 0px" font="--headline3" color="--light">
					<Strong>
						Exclusive Franchise Benefits
					</Strong>
				</Text>
				<Text font="--base" color="--light" margin="40px 0px 0px 0px">
					<Strong>
						Comprehensive Training
					</Strong>
					: From food preparation techniques to customer service excellence, we provide in-depth training programs tailored to your needs.
					<br />
					<br />
					<Strong>
						Marketing Support
					</Strong>
					: Our marketing team creates customized campaigns to attract customers in your area and promote brand awareness.
					<br />
					<br />
					<Strong>
						Operational Expertise
					</Strong>
					: With years of experience, we’ll guide you through every aspect of running a successful café, including inventory management, cost control, and staff recruitment.
				</Text>
			</Box>
			<Box
				md-width="50%"
				sm-margin="20px 0px 20px 0px"
				sm-width="100%"
				width="33.333%"
				padding="20px 20px 20px 20px"
				margin="156px 0px 100px 0px"
				lg-margin="56px 0px 30px 0px"
			>
				<Text color="--light" margin="0px 0px 0px 0px" font="--headline3">
					Sustainability at Our Core
				</Text>
				<Text margin="40px 0px 0px 0px" font="--base" color="--light">
					At Green Bliss Café, sustainability isn’t just a buzzword—it’s a way of life. From using biodegradable packaging to supporting local farmers, we take every step possible to minimize our environmental footprint. As a franchisee, you’ll be contributing to a healthier planet while building a profitable business.
				</Text>
			</Box>
		</Section>
		<Section padding="80px 0 90px 0" quarkly-title="Product-3">
			<Override slot="SectionContent" align-items="center" />
			<Text
				margin="0px 0px 20px 0px"
				font="normal 600 56px/1.2 --fontFamily-sans"
				text-align="center"
				lg-width="70%"
				md-width="100%"
			>
				<Strong font="--headline2">
					Menu Highlights
				</Strong>
			</Text>
			<Text
				margin="0px 0px 70px 0px"
				text-align="center"
				font="--lead"
				color="--darkL1"
				padding="0px 280px 0px 280px"
				lg-padding="0px 0 0px 0"
				lg-margin="0px 0px 50px 0px"
			>
				Our carefully curated menu is one of the primary reasons for our success. It appeals to a broad audience, from die-hard vegans to meat-lovers looking for something new. Some of our customer favorites include:
			</Text>
			<Box
				min-width="100px"
				min-height="100px"
				display="grid"
				grid-template-columns="repeat(3, 1fr)"
				grid-template-rows="auto"
				grid-gap="0 35px"
				md-grid-template-columns="1fr"
				md-grid-gap="40px 0"
				margin="0px 0px 50px 0px"
				md-margin="0px 0px 50px 0px"
			>
				<Box
					min-width="100px"
					min-height="100px"
					display="flex"
					flex-direction="column"
					align-items="center"
				>
					<Image
						src="https://images.unsplash.com/photo-1520066391310-428f06ebd602?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=2000"
						display="block"
						max-width="100%"
						margin="0px 0px 25px 0px"
						height="300px"
						width="100%"
						object-fit="cover"
						sm-height="220px"
						object-position="top"
						srcSet="https://images.unsplash.com/photo-1520066391310-428f06ebd602?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=500 500w,https://images.unsplash.com/photo-1520066391310-428f06ebd602?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=800 800w,https://images.unsplash.com/photo-1520066391310-428f06ebd602?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=1080 1080w,https://images.unsplash.com/photo-1520066391310-428f06ebd602?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=1600 1600w,https://images.unsplash.com/photo-1520066391310-428f06ebd602?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=2000 2000w,https://images.unsplash.com/photo-1520066391310-428f06ebd602?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=2600 2600w,https://images.unsplash.com/photo-1520066391310-428f06ebd602?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=3200 3200w"
						sizes="(max-width: 576px) 100vw,(max-width: 767px) 100vw,(max-width: 992px) 100vw,100vw"
					/>
					<Text
						margin="0px 0px 15px 0px"
						color="--darkL1"
						font="--base"
						text-align="center"
						text-transform="uppercase"
					>
						A colorful mix of quinoa, roasted vegetables, and our signature turmeric tahini dressing.
					</Text>
					<Text margin="0px 0px 15px 0px" font="--headline4" text-align="center">
						Rainbow Power Bowl
					</Text>
				</Box>
				<Box
					min-width="100px"
					min-height="100px"
					display="flex"
					flex-direction="column"
					align-items="center"
				>
					<Image
						src="https://images.unsplash.com/photo-1585238340764-c6f1f6fe1a6d?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&h=2000"
						display="block"
						max-width="100%"
						margin="0px 0px 25px 0px"
						height="300px"
						width="100%"
						object-fit="cover"
						sm-height="220px"
						srcSet="https://images.unsplash.com/photo-1585238340764-c6f1f6fe1a6d?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&h=2000&w=500 500w,https://images.unsplash.com/photo-1585238340764-c6f1f6fe1a6d?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&h=2000&w=800 800w,https://images.unsplash.com/photo-1585238340764-c6f1f6fe1a6d?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&h=2000&w=1080 1080w,https://images.unsplash.com/photo-1585238340764-c6f1f6fe1a6d?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&h=2000&w=1600 1600w,https://images.unsplash.com/photo-1585238340764-c6f1f6fe1a6d?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&h=2000&w=2000 2000w,https://images.unsplash.com/photo-1585238340764-c6f1f6fe1a6d?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&h=2000&w=2600 2600w,https://images.unsplash.com/photo-1585238340764-c6f1f6fe1a6d?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&h=2000&w=3200 3200w"
						sizes="(max-width: 576px) 100vw,(max-width: 767px) 100vw,(max-width: 992px) 100vw,100vw"
					/>
					<Text
						margin="0px 0px 15px 0px"
						color="--darkL1"
						font="--base"
						text-align="center"
						text-transform="uppercase"
					>
						A mouthwatering, plant-based burger that’s as satisfying as the real thing.
					</Text>
					<Text margin="0px 0px 15px 0px" font="--headline4" text-align="center">
						<Strong
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							Green Bliss Burger
						</Strong>
					</Text>
				</Box>
				<Box
					min-width="100px"
					min-height="100px"
					display="flex"
					flex-direction="column"
					align-items="center"
				>
					<Image
						src="https://images.unsplash.com/photo-1680588194311-6eb00e9c1e25?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&h=2000"
						display="block"
						max-width="100%"
						margin="0px 0px 25px 0px"
						height="300px"
						width="100%"
						object-fit="cover"
						sm-height="220px"
						srcSet="https://images.unsplash.com/photo-1680588194311-6eb00e9c1e25?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&h=2000&w=500 500w,https://images.unsplash.com/photo-1680588194311-6eb00e9c1e25?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&h=2000&w=800 800w,https://images.unsplash.com/photo-1680588194311-6eb00e9c1e25?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&h=2000&w=1080 1080w,https://images.unsplash.com/photo-1680588194311-6eb00e9c1e25?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&h=2000&w=1600 1600w,https://images.unsplash.com/photo-1680588194311-6eb00e9c1e25?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&h=2000&w=2000 2000w,https://images.unsplash.com/photo-1680588194311-6eb00e9c1e25?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&h=2000&w=2600 2600w,https://images.unsplash.com/photo-1680588194311-6eb00e9c1e25?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&h=2000&w=3200 3200w"
						sizes="(max-width: 576px) 100vw,(max-width: 767px) 100vw,(max-width: 992px) 100vw,100vw"
					/>
					<Text
						margin="0px 0px 15px 0px"
						color="--darkL1"
						font="--base"
						text-align="center"
						text-transform="uppercase"
					>
						A refreshing blend of mango, turmeric, and coconut milk—perfect for a midday energy boost.
					</Text>
					<Text margin="0px 0px 15px 0px" font="--headline4" text-align="center">
						Golden Glow Smoothie
					</Text>
				</Box>
			</Box>
		</Section>
		<Section padding="80px 0 80px 0" sm-padding="60px 0 60px 0">
			<Override slot="SectionContent" flex-direction="row" flex-wrap="wrap" />
			<Box
				padding="0px 160px 0px 0px"
				border-radius="24px"
				margin="0px 0px 0px 0px"
				width="60%"
				lg-padding="0px 50px 0px 0px"
				lg-width="50%"
				md-width="100%"
				md-padding="0px 0px 0px 0px"
				display="flex"
				flex-direction="column"
				align-items="flex-start"
				md-margin="0px 0px 60px 0px"
				md-align-items="center"
			>
				<Text
					margin="0px 0px 16px 0px"
					font="--headline2"
					color="--dark"
					md-text-align="center"
					sm-font="normal 700 32px/1.2 &quot;Source Sans Pro&quot;, sans-serif"
				>
					<Strong>
						Franchise Opportunities
					</Strong>
				</Text>
				<Text
					margin="0px 0px 40px 0px"
					font="--base"
					color="--greyD3"
					md-text-align="center"
					md-margin="0px 0px 20px 0px"
				>
					Becoming a Green Bliss Café franchisee is your opportunity to own a business that aligns with your values and delivers financial success. Here’s how we ensure your journey is seamless:
				</Text>
				<Link
					href="/faq"
					text-decoration-line="initial"
					color="--light"
					font="--lead"
					hover-opacity="0.9"
					background="--color-indigo"
					border-radius="8px"
					padding="11px 24px 12px 24px"
				>
					Know More
				</Link>
			</Box>
			<Box
				display="flex"
				lg-flex-wrap="wrap"
				width="40%"
				flex-direction="column"
				lg-width="50%"
				md-width="100%"
			>
				<Box
					width="100%"
					display="flex"
					flex-direction="row"
					margin="0px 0px 40px 0px"
					lg-margin="0px 4% 15px 0px"
					sm-width="100%"
					sm-margin="0px 0px 30px 0px"
				>
					<Text
						padding="7px 24px 8px 24px"
						margin="0px 30px 0px 0px"
						font="--headline3"
						border-radius="50px"
						align-items="center"
						display="flex"
						justify-content="center"
						color="--darkL2"
						width="49px"
						height="49px"
						background="--color-lightD1"
						sm-margin="0px 14px 0px 0px"
					>
						1
					</Text>
					<Box>
						<Text margin="0px 0px 18px 0px" color="--darkL2" font="--headline3" lg-text-align="left">
							Site Selection
						</Text>
						<Text margin="0px 0px 0px 0px" color="--greyD3" font="--base" lg-text-align="left">
							Location is everything. Our real estate experts will help you find the perfect spot for your café—whether it’s in a bustling urban area or a charming suburban neighborhood.
						</Text>
					</Box>
				</Box>
				<Box
					width="100%"
					display="flex"
					flex-direction="row"
					margin="0px 0px 40px 0px"
					lg-margin="0px 4% 15px 0px"
					sm-width="100%"
					sm-margin="0px 0px 30px 0px"
				>
					<Text
						padding="7px 24px 8px 24px"
						margin="0px 30px 0px 0px"
						font="--headline3"
						border-radius="50px"
						align-items="center"
						display="flex"
						justify-content="center"
						color="--darkL2"
						width="49px"
						height="49px"
						background="--color-lightD1"
						sm-margin="0px 14px 0px 0px"
					>
						2
					</Text>
					<Box>
						<Text margin="0px 0px 18px 0px" color="--darkL2" font="--headline3" lg-text-align="left">
							Interior Design and Branding
						</Text>
						<Text margin="0px 0px 0px 0px" color="--greyD3" font="--base" lg-text-align="left">
							Our cafés are designed to create an inviting, Instagram-worthy atmosphere that encourages repeat visits. From natural wood accents to lush greenery, every detail reflects our commitment to sustainability and style.
						</Text>
					</Box>
				</Box>
				<Box
					width="100%"
					display="flex"
					flex-direction="row"
					margin="0px 0px 40px 0px"
					lg-margin="0px 4% 15px 0px"
					sm-width="100%"
					sm-margin="0px 0px 30px 0px"
				>
					<Text
						padding="7px 24px 8px 24px"
						margin="0px 30px 0px 0px"
						font="--headline3"
						border-radius="50px"
						align-items="center"
						display="flex"
						justify-content="center"
						color="--darkL2"
						width="49px"
						height="49px"
						background="--color-lightD1"
						sm-margin="0px 14px 0px 0px"
					>
						3
					</Text>
					<Box>
						<Text margin="0px 0px 18px 0px" color="--darkL2" font="--headline3" lg-text-align="left">
							Ongoing Support
						</Text>
						<Text margin="0px 0px 0px 0px" color="--greyD3" font="--base" lg-text-align="left">
							You’re never alone on this journey. Our team is always available to answer questions, provide guidance, and celebrate your wins.
						</Text>
					</Box>
				</Box>
			</Box>
		</Section>
		<Components.Cta>
			<Override slot="text" />
			<Override slot="text1" />
		</Components.Cta>
		<Input display="block" placeholder-color="LightGray" background="white" />
		<Components.Form3 />
		<Components.Footer3 />
		<RawHtml>
			<style place={"endOfHead"} rawKey={"614ce40335c5c8001f7746de"}>
				{":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n}"}
			</style>
		</RawHtml>
	</Theme>;
});